import { connect } from "react-redux"
import DeleteLayout from "./DeleteLayout"
import { withRouter } from "react-router"
import { compose } from "redux"
import { removeLayoutDetails, clearLayoutSecondarySelection } from "../../../../store/actions/reduxActions"
import { withSnackbar } from "notistack"

const mapStateToProps = (_state, _props) => ({})

const mapDispatchToProps = (dispatch, _props) => ({
	removeLayout: (layoutId) => {
		dispatch(removeLayoutDetails(layoutId))
		dispatch(clearLayoutSecondarySelection(layoutId))
	},
})

export default compose(withRouter, withSnackbar, connect(mapStateToProps, mapDispatchToProps))(DeleteLayout)
